<template>
  <div class="card-body">
    <h5 class="card-title mb-3">Integration With Threads</h5>

    <div class="row row-cols-xxl-4 row-cols-lg-3 row-cols-md-2 row-cols-1">
      <div class="col" v-for="(val, key) in integrationList" :key="key">
        <div class="card card-body" style="background: #f1f5f9">
          <div
            class="text-end dropdown"
            style="position: absolute; right: 20px"
          >
            <i
              class="ri-edit-line text-black pointer me-2"
              @click="toggleEdit(val)"
            ></i>
            <i
              class="ri-delete-bin-6-line text-danger pointer"
              @click="toggleDelete(val.id)"
            ></i>
          </div>

          <div class="d-flex mb-4 align-items-center">
            <div class="flex-shrink-0">
              <div class="avatar-xs">
                <div class="avatar-title rounded bg-dark fs-14">
                  <img
                    src="/img/new-channels/threads.svg"
                    alt="Threads"
                    width="20"
                    height="20"
                    style="filter: invert(1)"
                  />
                </div>
              </div>
            </div>
            <div class="flex-grow-1 ms-2">
              <h5 class="card-title mb-1">
                {{ val.integration_data.accountName || "-" }}
              </h5>
              <p class="text-muted mb-0">
                @{{ val.integration_data.username || "-" }}
              </p>
            </div>
          </div>

          <span class="card-timestamp text-muted mb-0 fs-12">
            Added {{ val.created_at }}
          </span>
          <span class="card-timestamp text-muted fs-12">
            Updated {{ val.updated_at }}
          </span>

          <base-button
            class="btn btn-primary btn-sm mt-2"
            @click="toggleIntegration(val)"
            v-if="!val.status"
          >
            Activate
          </base-button>
          <base-button
            class="btn btn-outline-danger btn-sm mt-2"
            @click="toggleIntegration(val)"
            v-else
          >
            Deactivate
          </base-button>
        </div>
      </div>

      <!-- Add new card -->
      <div class="col">
        <div class="card card-height-100" style="background: #f1f5f9">
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center"
          >
            <i
              class="ri-add-circle-fill pointer"
              style="font-size: 45px"
              @click="modal.create = true"
            ></i>
            <label>Add</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalAdd
    :isOpen="modal.create"
    @onClose="modal.create = false"
    @onAdd="fetchData"
  />

  <ModalAdd
    :isOpen="modal.edit"
    modal-title="Edit Threads"
    :formEdit="selectedEdit"
    @onClose="modal.edit = false"
    @onAdd="fetchData"
  />

  <modal-delete
    :showModal="modal.delete"
    :loading="modal.loading"
    :isInformation="'Are You Sure Want To Remove This Integration?'"
    :submitText="'Remove'"
    @onHidden="modal.delete = false"
    @onSubmit="removeIntegration"
  />
</template>

<script>
import { debounce } from "lodash";
import ModalAdd from "@/views/integration/components/threads/ModalAdd.vue";

export default {
  components: { ModalAdd },

  data() {
    return {
      selectedIntegration: null,
      selectedEdit: null,
      modal: {
        create: false,
        edit: false,
        delete: false,
        loading: false,
      },
      integrationList: [],
    };
  },

  created() {
    this.$store.dispatch("ticket/getBranchOffice");
    this.$store.dispatch("ticket/getGroupManagement", "");
  },

  methods: {
    async fetchData() {
      try {
        const response = await this.$axios.get(
          `api/${this.$store.getters.appId.hashed}/integrate`
        );
        const channelData = response.data.data.find(
          (item) => item.name === "threads"
        );
        this.integrationList = channelData ? channelData.integration : [];
      } catch (error) {
        this.errorToast(error);
      }
    },

    toggleEdit(val) {
      this.selectedEdit = val;
      this.modal.edit = true;
    },

    toggleDelete(id) {
      this.selectedIntegration = id;
      this.modal.delete = true;
    },

    async removeIntegration() {
      this.$store.dispatch("loading/updateIsLoading", true);
      this.modal.loading = true;
      try {
        await this.$axios.delete(
          `api/${this.$store.getters.appId.hashed}/v3/remove-integration`,
          { params: { integrationId: this.selectedIntegration } }
        );
        this.successToast("Threads integration removed");
        await this.fetchData();
      } catch (error) {
        this.errorToast(error);
      } finally {
        this.$store.dispatch("loading/updateIsLoading", false);
        this.modal.loading = false;
        this.modal.delete = false;
      }
    },

    toggleIntegration(data) {
      const param = { integrationId: data.id, status: data.status };
      this.submitToggle(param, this);
    },

    submitToggle: debounce(async (param, vm) => {
      await vm.$store.dispatch("integration/enableDisableIntegration", param);
      vm.fetchData();
    }, 300),
  },

  async mounted() {
    await this.fetchData();
  },
};
</script>

<style lang="scss" scoped></style>
